import { Navbar } from "../components/layouts/Navbar"
import { ResumoCards } from "../components/dashboard/ResumoCards"



export const Dashboard = () => (
  <div className="min-h-screen bg-gray-50">
    <Navbar />
    <div className="p-6">
      <ResumoCards />
      {/* Aqui virão os gráficos e dropdown de ano */}
    </div>
  </div>
)